// 'settings' namespace — keys are prefixed 'settings.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'settings.about.title': 'О приложении',
  'settings.about.app': 'Приложение',
  'settings.about.server': 'Сервер',
  'settings.about.build': 'сборка',
  'settings.title': 'Настройки',
  'settings.subtitle': 'Язык, перо, данные на устройстве и учётная запись.',
  'settings.updateAvailable': 'Доступна новая версия приложения',
  'settings.updateNow': 'Обновить',
  'settings.saved': 'Сохранено',

  'settings.appearance': 'Язык и вид',
  'settings.appearanceHelp': 'Язык интерфейса. Греческие тексты и задания не переводятся.',
  'settings.language': 'Язык интерфейса',
  'settings.languageHelp': 'Сохраняется в учётной записи и на этом устройстве.',
  'settings.theme': 'Тема',
  'settings.theme.system': 'Как в системе',
  'settings.theme.light': 'Светлая',
  'settings.theme.dark': 'Тёмная',
  'settings.displayName': 'Имя',
  'settings.displayNameHelp': 'Так вас увидит преподаватель, если вы поделитесь работой.',

  'settings.pen': 'Перо',
  'settings.penHelp': 'Значения по умолчанию для всех новых страниц на этом устройстве.',
  'settings.inkColor': 'Цвет чернил',
  'settings.inkColor.0': 'Сине-чёрный',
  'settings.inkColor.1': 'Чёрный',
  'settings.inkColor.2': 'Синий',
  'settings.inkWidth': 'Толщина линии',
  'settings.fingerDrawing': 'Рисование пальцем',
  'settings.fingerDrawingHelp': 'Пока Apple Pencil не использовался, писать можно и пальцем. Как только приложение замечает Pencil, касания пальцем и ладонью перестают рисовать (защита от случайных штрихов) и служат только для прокрутки и масштаба.',
  'settings.leftHanded': 'Режим для левши',
  'settings.leftHandedHelp': 'Панель инструментов и образец переносятся на правую сторону, чтобы рука не закрывала их.',
  'settings.template': 'Разлиновка по умолчанию',
  'settings.templateHelp': 'Для новых страниц копирования и свободного письма. В экзамене всегда используется экзаменационный бланк.',
  'settings.template.lined': 'Линейка',
  'settings.template.grid': 'Клетка',
  'settings.template.blank': 'Чистый лист',
  'settings.pencilNote': 'Двойное касание Apple Pencil и жесты Pencil Pro недоступны веб-приложениям — переключайте инструменты на панели или клавишами P / E / H.',

  'settings.recall': 'Воспроизведение',
  'settings.recallHelp': 'Как долго показывать образец перед тем, как он скрывается.',
  'settings.studyTime': 'Время на изучение',
  'settings.studyTimeHelp': 'После этого образец скрывается автоматически; скрыть его можно и раньше.',
  'settings.seconds': '{n} сек',
  'settings.minutes': '{n} мин',
  'settings.recallStrict': 'Строгий режим по умолчанию',
  'settings.recallStrictHelp': 'После скрытия образец нельзя открыть снова до отправки работы.',

  'settings.localData': 'Данные на устройстве',
  'settings.localDataHelp': 'Черновики сначала сохраняются здесь, затем синхронизируются с сервером.',
  'settings.storageUsed': 'Занято в хранилище',
  'settings.storageUnknown': 'Браузер не сообщает объём хранилища.',
  'settings.unsyncedPages': 'Не синхронизировано',
  'settings.unsyncedHelp': 'Страницы, которые пока есть только на этом устройстве.',
  'settings.pagesN': 'стр.: {n}',
  'settings.allSynced': 'Всё на сервере',
  'settings.syncNow': 'Синхронизировать',
  'settings.persist': 'Постоянное хранилище',
  'settings.persistHelp': 'Попросить браузер не удалять данные приложения при нехватке места. Safari может отказать или всё равно очистить данные.',
  'settings.persistRequest': 'Запросить',
  'settings.persistOn': 'Включено',
  'settings.persistGranted': 'Браузер обещал не удалять данные',
  'settings.persistDenied': 'Браузер не дал гарантии — синхронизируйте работы почаще',
  'settings.localPrivacy': 'Черновики хранятся на этом устройстве в IndexedDB, пока не синхронизируются с сервером. iPadOS может очистить хранилище веб-приложения, если им долго не пользоваться или мало места, — поэтому мы синхронизируем сразу, как появляется сеть. При выходе из аккаунта локальные данные удаляются.',
  'settings.clearLocal': 'Очистить данные на устройстве',
  'settings.clearLocalHelp': 'Удаляет локальные копии черновиков. Синхронизированные работы останутся на сервере.',
  'settings.clearLocalButton': 'Очистить',
  'settings.clearTitle': 'Очистить данные на устройстве?',
  'settings.clearText': 'Все страницы уже на сервере — локальные копии будут удалены и скачаются снова при открытии.',
  'settings.clearUnsyncedText': 'На устройстве {n} стр. ещё не отправлены на сервер. После очистки они будут потеряны навсегда.',
  'settings.clearAck': 'Я понимаю, что несинхронизированные страницы ({n}) будут удалены без возможности восстановления',

  'settings.privacy': 'Конфиденциальность',
  'settings.privacyHelp': 'Что происходит с вашими работами.',
  'settings.aiNotice': 'Когда вы отправляете работу на проверку, изображения рукописи и текст передаются выбранному ИИ-провайдеру ({provider}) для распознавания почерка и оценки.',
  'settings.aiNotice2': 'Приложение использует эти данные только для распознавания и проверки ваших работ и ни для чего другого. Черновики до отправки никуда не передаются.',
  'settings.providerMock': 'тестовый режим без внешнего провайдера',
  'settings.privateByDefault': 'Все работы приватны. Преподаватель видит только те попытки, которыми вы поделились сами, и доступ можно отозвать в любой момент.',

  'settings.account': 'Учётная запись',
  'settings.accountHelp': 'Вход, выход, экспорт и удаление данных.',
  'settings.rolesLine': 'Роли: {roles}',
  'settings.role.student': 'Ученик',
  'settings.role.teacher': 'Преподаватель',
  'settings.role.admin': 'Администратор',
  'settings.sessionExpiry': 'Вход действует до',
  'settings.sessionExpiryHelp': 'Вход выполнен {created}. Потом нужно будет войти снова по коду из письма.',
  'settings.signOutHelp': 'Выйти на этом устройстве. Локальные черновики будут удалены.',
  'settings.signOutAll': 'Выйти на всех устройствах',
  'settings.signOutAllHelp': 'Завершает все активные сеансы — например, если вы потеряли iPad.',
  'settings.signOutAllButton': 'Выйти везде',
  'settings.signOutAllTitle': 'Выйти на всех устройствах?',
  'settings.signOutAllText': 'Все сеансы, включая этот, будут завершены.',
  'settings.loggedOutEverywhere': 'Вы вышли на всех устройствах',
  'settings.export': 'Экспорт данных',
  'settings.exportHelp': 'JSON-файл со всеми вашими работами, расшифровками и оценками.',
  'settings.exportButton': 'Скачать JSON',
  'settings.deleteAccount': 'Удалить учётную запись',
  'settings.deleteAccountHelp': 'Безвозвратно закрывает доступ и удаляет ваши работы.',
  'settings.deleteAccountButton': 'Удалить…',
  'settings.deleteTitle': 'Удалить учётную запись?',
  'settings.deleteIntro': 'Это действие нельзя отменить.',
  'settings.deleteC1': 'Все ваши работы, рукописи и оценки будут удалены.',
  'settings.deleteC2': 'Доступ преподавателей ко всем работам будет отозван.',
  'settings.deleteC3': 'Вход будет закрыт на всех устройствах, адрес исключится из списка доступа.',
  'settings.deleteC4': 'Вернуть доступ сможет только администратор, но удалённые работы не восстановятся.',
  'settings.deleteExportFirst': 'Совет: сначала скачайте экспорт данных.',
  'settings.deleteTypeEmail': 'Чтобы подтвердить, введите ваш адрес: {email}',
  'settings.deleteForever': 'Удалить навсегда',
  'settings.deleted': 'Учётная запись удалена',

  'settings.adminTitle': 'Администрирование',
  'settings.adminText': 'Провайдер ИИ, модели и бюджет настраиваются в разделе администрирования.',
  'settings.openAdmin': 'Открыть',
};

const en: Record<string, string> = {
  'settings.about.title': 'About',
  'settings.about.app': 'App',
  'settings.about.server': 'Server',
  'settings.about.build': 'build',
  'settings.title': 'Settings',
  'settings.subtitle': 'Language, pen, data on this device and your account.',
  'settings.updateAvailable': 'A new version of the app is available',
  'settings.updateNow': 'Update',
  'settings.saved': 'Saved',

  'settings.appearance': 'Language & appearance',
  'settings.appearanceHelp': 'Interface language. Greek texts and tasks are never translated.',
  'settings.language': 'Interface language',
  'settings.languageHelp': 'Saved to your account and on this device.',
  'settings.theme': 'Theme',
  'settings.theme.system': 'System',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.displayName': 'Name',
  'settings.displayNameHelp': 'What a teacher sees when you share work with them.',

  'settings.pen': 'Pen',
  'settings.penHelp': 'Defaults for all new pages on this device.',
  'settings.inkColor': 'Ink colour',
  'settings.inkColor.0': 'Blue-black',
  'settings.inkColor.1': 'Black',
  'settings.inkColor.2': 'Blue',
  'settings.inkWidth': 'Line width',
  'settings.fingerDrawing': 'Draw with finger',
  'settings.fingerDrawingHelp': 'Until Apple Pencil is used you can write with a finger. Once the app sees a Pencil, finger and palm touches stop drawing (palm rejection) and only scroll and zoom.',
  'settings.leftHanded': 'Left-handed mode',
  'settings.leftHandedHelp': 'Moves the toolbar and reference to the right so your hand does not cover them.',
  'settings.template': 'Default paper',
  'settings.templateHelp': 'For new copy and free-writing pages. Exams always use the exam sheet.',
  'settings.template.lined': 'Lined',
  'settings.template.grid': 'Grid',
  'settings.template.blank': 'Blank',
  'settings.pencilNote': 'Apple Pencil double-tap and Pencil Pro gestures are not available to web apps — switch tools in the toolbar or with the P / E / H keys.',

  'settings.recall': 'Recall',
  'settings.recallHelp': 'How long the model text is shown before it hides.',
  'settings.studyTime': 'Study time',
  'settings.studyTimeHelp': 'The model hides automatically afterwards; you can hide it earlier.',
  'settings.seconds': '{n} s',
  'settings.minutes': '{n} min',
  'settings.recallStrict': 'Strict mode by default',
  'settings.recallStrictHelp': 'Once hidden, the model cannot be shown again until you submit.',

  'settings.localData': 'Data on this device',
  'settings.localDataHelp': 'Drafts are saved here first, then synced to the server.',
  'settings.storageUsed': 'Storage used',
  'settings.storageUnknown': 'The browser does not report storage size.',
  'settings.unsyncedPages': 'Not synced',
  'settings.unsyncedHelp': 'Pages that exist only on this device so far.',
  'settings.pagesN': '{n} page(s)',
  'settings.allSynced': 'All on the server',
  'settings.syncNow': 'Sync now',
  'settings.persist': 'Persistent storage',
  'settings.persistHelp': 'Ask the browser not to delete app data when space runs low. Safari may refuse or clear data anyway.',
  'settings.persistRequest': 'Request',
  'settings.persistOn': 'On',
  'settings.persistGranted': 'The browser promised to keep the data',
  'settings.persistDenied': 'The browser gave no guarantee — sync your work often',
  'settings.localPrivacy': 'Drafts are stored on this device in IndexedDB until they sync to the server. iPadOS may clear a web app’s storage after long inactivity or when space is low — that is why we sync as soon as there is a connection. Signing out deletes local data.',
  'settings.clearLocal': 'Clear data on this device',
  'settings.clearLocalHelp': 'Deletes local copies of drafts. Synced work stays on the server.',
  'settings.clearLocalButton': 'Clear',
  'settings.clearTitle': 'Clear data on this device?',
  'settings.clearText': 'Everything is already on the server — local copies are deleted and downloaded again when opened.',
  'settings.clearUnsyncedText': '{n} page(s) on this device have not reached the server. Clearing deletes them permanently.',
  'settings.clearAck': 'I understand that {n} unsynced page(s) will be deleted and cannot be recovered',

  'settings.privacy': 'Privacy',
  'settings.privacyHelp': 'What happens to your work.',
  'settings.aiNotice': 'When you submit work for checking, the handwriting images and text are sent to the configured AI provider ({provider}) for handwriting recognition and evaluation.',
  'settings.aiNotice2': 'This app uses that data only to recognise and check your work, and for nothing else. Drafts are not sent anywhere before you submit.',
  'settings.providerMock': 'test mode without an external provider',
  'settings.privateByDefault': 'All work is private. A teacher sees only the attempts you share yourself, and you can revoke access at any time.',

  'settings.account': 'Account',
  'settings.accountHelp': 'Sign-in, sign-out, export and deletion.',
  'settings.rolesLine': 'Roles: {roles}',
  'settings.role.student': 'Student',
  'settings.role.teacher': 'Teacher',
  'settings.role.admin': 'Admin',
  'settings.sessionExpiry': 'Signed in until',
  'settings.sessionExpiryHelp': 'Signed in {created}. After that you sign in again with an emailed code.',
  'settings.signOutHelp': 'Sign out on this device. Local drafts are deleted.',
  'settings.signOutAll': 'Sign out everywhere',
  'settings.signOutAllHelp': 'Ends all active sessions — for example if you lost your iPad.',
  'settings.signOutAllButton': 'Sign out everywhere',
  'settings.signOutAllTitle': 'Sign out on all devices?',
  'settings.signOutAllText': 'All sessions, including this one, will end.',
  'settings.loggedOutEverywhere': 'Signed out on all devices',
  'settings.export': 'Export data',
  'settings.exportHelp': 'A JSON file with all your work, transcripts and evaluations.',
  'settings.exportButton': 'Download JSON',
  'settings.deleteAccount': 'Delete account',
  'settings.deleteAccountHelp': 'Permanently closes access and deletes your work.',
  'settings.deleteAccountButton': 'Delete…',
  'settings.deleteTitle': 'Delete your account?',
  'settings.deleteIntro': 'This cannot be undone.',
  'settings.deleteC1': 'All your work, handwriting and evaluations will be deleted.',
  'settings.deleteC2': 'Teacher access to all your work will be revoked.',
  'settings.deleteC3': 'Sign-in is closed on every device and your address is removed from the allowlist.',
  'settings.deleteC4': 'Only an administrator can restore access, and deleted work cannot be recovered.',
  'settings.deleteExportFirst': 'Tip: download the data export first.',
  'settings.deleteTypeEmail': 'To confirm, type your address: {email}',
  'settings.deleteForever': 'Delete forever',
  'settings.deleted': 'Account deleted',

  'settings.adminTitle': 'Administration',
  'settings.adminText': 'AI provider, models and budget are configured in the admin area.',
  'settings.openAdmin': 'Open',
};

export default { ru, en };
